export { default } from './GetInTouchQrView';



// WEBPACK FOOTER //
// ./src/components/views/GetInTouchQrView/index.js